import React from "react";
import { useState } from "react";
import BotonEliminaIp from "./botoneliminarIp";
import {
  Card,
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  Modal,
  Badge,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Table,
  UncontrolledTooltip,
  Alert,
  InputGroup,
} from "reactstrap";

const ComponenteIps = (props) => {
  var createReactClass = require("create-react-class");
  const [valorIp, setvalorIp] = useState([]);
  const [listAlert, setListAlert] = useState([]);

  const validaIp = (ipvalor) => {
    let valor = "";
    let rango = 0;
    let ipvalido = true;
    let ipajustada = "";
    try {
      if (ipvalor.length > 0) {
        for (let i = 0; i < ipvalor.length; i++) {
          if (ipvalor.substr(i, 1) == ".") {
            rango++;
            if (parseInt(valor) >= 0 && parseInt(valor) < 256) {
              console.log(parseInt(valor));
              ipajustada = ipajustada + parseInt(valor) + ".";
            } else {
              ipvalido = false;
              console.log("error en el rango " + rango);
            }
            valor = "";
          } else if (i == ipvalor.length - 1) {
            valor = valor + ipvalor.substr(i, 1) + "";
            rango++;
            if (parseInt(valor) >= 0 && parseInt(valor) < 256) {
              console.log(parseInt(valor));
              ipajustada = ipajustada + parseInt(valor);
            } else {
              ipvalido = false;
              console.log("error en el rango " + rango);
            }
          } else {
            valor = valor + ipvalor.substr(i, 1) + "";
          }
        }
      }
      if (rango != 4) {
        ipvalido = false;
      }
      if (ipvalido) {
        return { valida: ipvalido, IpAjustada: ipajustada };
      } else {
        return { valida: false, IpAjustada: "" };
      }
    } catch {
      console.log("error en la ip");
      return { valida: false, IpAjustada: "" };
    }
  };

  const actualizavalorip = (event) => {
    event.preventDefault();
    setvalorIp(event.target.value);
  };
  const deleteElementFromArr = () => {
    if (listAlert.length > 0) {
      let temp = listAlert.slice();
      temp.splice(0, 1);
      setListAlert(temp);
    }
  };
  const deleteAlert = (alert) => {
    console.log("elimina alerta");
    console.log(listAlert);
    setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
  };
  const [Ips, setIps] = useState([]);
  const [IpAct, setIpAct] = useState("");
  const agregaIp = () => {
    if (Ips.length < 5) {
      const IpValida = validaIp(valorIp);
      if (IpValida.valida) {
        let listaIps = [...Ips];
        listaIps.push(IpValida.IpAjustada);
        setIps([...listaIps]);
        setIpAct("");
        setvalorIp("");
        console.log("Ips");
        console.log(listaIps);
        props.infoIps(listaIps);
      } else {
        setListAlert([
          {
            description:
              "Ip invalida.Debe ser (0-255).(0-255).(0-255).(0-255) Ejemplo: 102.10.204.31",
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle",
          },
        ]);
        setTimeout(() => {
          deleteElementFromArr(listAlert);
        }, 5000);
      }
    } else {
      setListAlert([
        {
          description: "Ha completado el registro máximo de direcciones IP",
          type: "alert alert-alert show alert-dismissible fade alert-danger",
          icon: "fas fa-exclamation-circle",
        },
      ]);
    }
  };
  const eliminaIp = (index) => {
    if (index < Ips.length) {
      let listaIps = [...Ips];
      listaIps.splice(index, 1);
      setIps([...listaIps]);
    }
  };

  var Alerts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;
      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <div class={item.type} role="alert">
              <button
                type="button"
                class="close"
                aria-label="Close"
                onClick={() => deleteAlert(item)}
              >
                <span aria-hidden="true">×</span>
              </button>
              <span className="alert-inner--icon mr-3">
                <i className={item.icon} />
              </span>{" "}
              <span class="alert-inner--text">{item.description}</span>
            </div>
          );
        });
      }
      return <div className="toast-bottom-right">{newsTemplate}</div>;
    },
  });

  if (props.typeUser == "N") {
    return (
      <div>
        {/*<p style={{margin:"0px 0px 0px 5px", textAlign:"left"}}>Podrá registrar máximo 5 Ip's. Si no registra ninguna Ip, el usuario podrá acceder a la banca virtual sin esta restricción</p>*/}
        <InputGroup
          className="input-group-alternative mt-2 mb-2 mr-6"
          style={{ width: "300px" }}
        >
          <div className="inputs-icons-borderbott">
            <input
              className="form-control p-1"
              placeholder={"Ip nueva"}
              type="text"
              /*ref={refIps}*/
              style={{
                fontSize: "14px",
                border: "none",
                width: "250px",
                height: "25px",
                padding: "0px 0px 0px 0px",
                margin: "0px 0px 0px 0px",
              }}
              onChange={actualizavalorip}
              value={valorIp}
              autoFocus
            />

            <BotonEliminaIp
              eliminarIp={agregaIp}
              index={0}
              tipo={"agregar"}
            ></BotonEliminaIp>
          </div>
          <Alerts data={listAlert}></Alerts>
        </InputGroup>
        {Ips.map((item, index) => {
          return (
            <div
              className="mb-xl-0 ml-auto mr-auto p-1"
              style={{
                display: "inline-flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: "10px",
                background: "#FFFFFF",
                margin: "10px 10px 10px 10px",
                width: "300px",
              }}
            >
              <h1 style={{ display: "inline", fontSize: "18px" }}>{item}</h1>
              <BotonEliminaIp
                className="cursor-pointer"
                style={{ width: "50%" }}
                eliminarIp={eliminaIp}
                index={index}
                tipo={"eliminar"}
              ></BotonEliminaIp>
            </div>
          );
        })}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "50%",
            margin: "15px 0px 15px 0px",
          }}
          className="ml-auto mr-auto"
        >
          {/* <button onClick={()=>{finEdtIps()}} className="btn-icon bg-green text-white btn btn-block">Continuar</button> */}
        </div>
      </div>
    );
  } else {
    return (
      <div>
        {/*<p style={{margin:"0px 0px 0px 5px", textAlign:"left"}}>Podrá registrar máximo 5 Ip's. Si no registra ninguna Ip, el usuario podrá acceder a la banca virtual sin esta restricción</p>*/}
        <InputGroup
          className="input-group-alternative mt-2 mb-2"
          style={{ width: "300px" }}
        >
          <div className="inputs-icons-borderbott">
            <input
              className="form-control p-1"
              placeholder={"Ip nueva"}
              type="text"
              /*ref={refIps}*/
              style={{
                fontSize: "14px",
                border: "none",
                width: "250px",
                height: "25px",
                padding: "0px 0px 0px 0px",
                margin: "0px 0px 0px 0px",
              }}
              onChange={actualizavalorip}
              value={valorIp}
              autoFocus
            />

            <BotonEliminaIp
              eliminarIp={agregaIp}
              index={0}
              tipo={"agregar"}
            ></BotonEliminaIp>
          </div>
          <Alerts data={listAlert}></Alerts>
        </InputGroup>
        {Ips.map((item, index) => {
          return (
            <div
              className="mb-xl-0 ml-auto mr-auto p-1"
              style={{
                display: "inline-flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: "10px",
                background: "#FFFFFF",
                margin: "10px 10px 10px 10px",
                width: "300px",
              }}
            >
              <h1 style={{ display: "inline", fontSize: "18px" }}>{item}</h1>
              <BotonEliminaIp
                className="cursor-pointer"
                style={{ width: "50%" }}
                eliminarIp={eliminaIp}
                index={index}
                tipo={"eliminar"}
              ></BotonEliminaIp>
            </div>
          );
        })}
        {/* <div style={{display:"flex",justifyContent:"center",alignItems:"center", width:"50%", margin:"15px 0px 15px 0px"}}className="ml-auto mr-auto">
          <button
                  style={{width:"50%"}}
                  //onClick={pideotpcreacionusu}
                  className="bg-green text-white btn shadow btn-rounded btn-block btn-lg mt-3 mb-3 p-2 ml-auto mr-auto"
                  >
                    Crear Usuario
                </button>
          </div> */}
      </div>
    );
  }
};
export default ComponenteIps;
